/**
 * How long a run took, or has been going, from the server's own stamps.
 *
 * <p>Pure, and the clock is an argument: a rolling "running for" tested against the
 * real clock passes today and drifts tomorrow.
 *
 * @param {{status?: string, startedAt?: string|null, finishedAt?: string|null}} run
 * @param {number} now epoch millis, for a run still going
 * @returns {string|null} "took 4 min 12 s", "running for 3 min", or null when the
 *          server sent no stamps (runs made before they existed)
 */
export function runDuration(run, now = Date.now()) {
    if (!run?.startedAt) {
        return null;
    }
    const start = Date.parse(run.startedAt);
    if (Number.isNaN(start)) {
        return null;
    }
    if (run.finishedAt) {
        const end = Date.parse(run.finishedAt);
        return Number.isNaN(end) ? null : `took ${elapsed(end - start)}`;
    }
    if (run.status === 'RUNNING') {
        return `running for ${elapsed(now - start)}`;
    }
    return null;
}

/** "4 min 12 s", "48 s", "1 h 3 min" — the unit a person would say. */
export function elapsed(millis) {
    const seconds = Math.max(0, Math.round(millis / 1000));
    if (seconds < 60) {
        return `${seconds} s`;
    }
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        const rest = seconds % 60;
        return rest ? `${minutes} min ${rest} s` : `${minutes} min`;
    }
    const hours = Math.floor(minutes / 60);
    const restMin = minutes % 60;
    return restMin ? `${hours} h ${restMin} min` : `${hours} h`;
}
